import React, { useEffect } from "react";
import dayjs from "dayjs";

import { styled } from "@mui/styles";
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { Divider } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import { TextMainTopic } from "../../../../admin/carManagement/deliverySampleShuttle/editDetail";
import { TextTopic, TextData } from "../../../../shared/styledComponent";

require("dayjs/locale/th");
dayjs.locale("th");

const useStyles = makeStyles((theme) => ({
  Title: {
    fontSize: "30px",
  },
  typeAndModelDetail: {
    textAlign: "center",
  },
  GridPicture: {
    display: "flex",
    justifyContent: "center",
  },
  Avatar: {
    width: "350px",
    height: "200px",
    [theme.breakpoints.down("sm")]: {
      width: "250px",
      height: "150px",
    },
  },
  Dialog: {
    paddingBottom: "30px",
    "& .MuiPaper-root": {
      [theme.breakpoints.down("sm")]: {
        margin: "0",
      },
    },
  },
  DialogContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "blue",
    },
    [theme.breakpoints.down("sm")]: {
      height: "550px",
      overflowY: "auto",
      padding: "0",
    },
  },
  Grid: {
    width: "calc(100% - 50px)",
    marginLeft: "50px",
    [theme.breakpoints.down("md")]: {
      width: "calc(100% - 20px)",
      marginLeft: "0",
    },
  },
  Text: {
    fontSize: "23px",
    wordWrap: "break-word",
    color: "#525656",
    fontWeight: "500",
  },
  Icon: {
    marginTop: "3px",
    fontsize: "10px",
    marginRight: "3px",
  },
  Recipient: {
    color: "#525656",
    fontWeight: "500",
  },
  IconYellow: {
    color: "#DCA700",
  },
  GridTextIcon: {
    display: "flex",
  },
  Fixed: {
    backgroundColor: "#DCA700",
    "&:hover": {
      backgroundColor: "#ba8e04",
    },
  },
  Confirm: {
    backgroundColor: "green",
    "&:hover": {
      backgroundColor: "darkgreen",
    },
  },
  DialogActions: {
    paddingRight: "30px",
  },
  Button: {
    width: "150px",
    height: "50px",
  },
  TextButton: {
    color: "white",
  },
  IconWeight: {
    weight: "26px",
    height: "26px",
    marginRight: "3px",
  },
  IconImage: {
    weight: "30px",
    height: "30px",
    marginRight: "10px",
  },
}));

const GridContainText = styled(Grid)(({ theme }) => ({
  paddingRight: "24px",
  display: "flex",
}));
const DividerStyled = styled(Divider)(({ theme }) => ({
  height: "2px",

  margin: "10px 50px 10px 50px",
  borderStyle: "dashed",
  borderWidth: "0px 0px thin",
  borderColor: "rgba(145, 158, 171, 2)",
}));

const DialogShowDetailBooking = (props) => {
  const classes = useStyles();

  useEffect(() => {
    console.log(props.getValues("deleteOldFile"));
    console.log(props.getValues("attachment"));
  });
  return (
    <Dialog open={props.open} className={classes.Dialog} maxWidth="md">
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          paddingTop: "2rem",
          paddingBottom: "1rem",
        }}
      >
        <TextMainTopic>รายละเอียดตัวอย่างที่ต้องการส่ง</TextMainTopic>
      </div>
      <DialogContent className={classes.DialogContent}>
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <Grid container spacing={3} className={classes.Grid}>
            <GridContainText
              item
              xs={12}
              style={{ display: "flex", alignItems: "baseline" }}
            >
              <img
                className={`${classes.IconImage}`}
                src={"/assets/Image/Icon/samplelab.png"}
                alt="Logo"
              />
              <TextTopic>ชื่อตัวอย่าง</TextTopic>
              <TextData>&nbsp;&nbsp;{props.getValues("nameSample")}</TextData>
            </GridContainText>
            <GridContainText
              item
              xs={12}
              style={{ display: "flex", alignItems: "baseline" }}
            >
              {/* <SensorDoorIcon className={`${classes.Icon} ${classes.Recipient}`}/> */}
              <img
                className={`${classes.IconImage}`}
                src={"/assets/Image/Icon/samplelab.png"}
                alt="Logo"
              />
              <TextTopic>Grade</TextTopic>
              <TextData>&nbsp;&nbsp;{props.getValues("nameGrade")}</TextData>
            </GridContainText>
            <GridContainText
              item
              xs={12}
              style={{ display: "flex", alignItems: "baseline" }}
            >
              {/* <FormatListNumberedIcon className={`${classes.Icon} ${classes.Recipient}`} /> */}
              <img
                className={`${classes.IconImage}`}
                src={"/assets/Image/Icon/samplelab.png"}
                alt="Logo"
              />
              <TextTopic>Lot Number</TextTopic>
              <TextData>&nbsp;&nbsp;{props.getValues("lotNumber")}</TextData>
            </GridContainText>

            <GridContainText
              item
              xs={12}
              sm={6}
              lg={6}
              style={{ display: "flex", alignItems: "baseline" }}
            >
              {/* <PersonIcon className={`${classes.IconWeight}`}src={`./assets/Image/Icon/weightOfProducts.png`} alt="weightOfProducts"/> */}
              <img
                className={`${classes.IconImage}`}
                src={"/assets/Image/Icon/sender.png"}
                alt="Logo"
              />
              <TextTopic>ผู้ส่ง</TextTopic>
              <TextData>&nbsp;&nbsp;{props.getValues("nameSender")}</TextData>
            </GridContainText>
            <GridContainText
              item
              xs={12}
              sm={6}
              lg={6}
              style={{ display: "flex", alignItems: "baseline" }}
            >
              {/* <PersonIcon className={`${classes.IconWeight}`} alt="weightOfProducts"/> */}
              <img
                className={`${classes.IconImage}`}
                src={"/assets/Image/Icon/sender.png"}
                alt="Logo"
              />
              <TextTopic>เบอร์ผู้ส่ง</TextTopic>
              <TextData>&nbsp;&nbsp;{props.getValues("phoneSender")}</TextData>
            </GridContainText>
            <GridContainText
              item
              xs={12}
              sm={6}
              lg={6}
              style={{ display: "flex", alignItems: "baseline" }}
            >
              {/* <PersonIcon className={`${classes.IconWeight}`}src={`./assets/Image/Icon/weightOfProducts.png`} alt="weightOfProducts"/> */}
              <img
                className={`${classes.IconImage}`}
                src={"/assets/Image/Icon/recipient.png"}
                alt="Logo"
              />
              <TextTopic>ผู้รับ</TextTopic>
              <TextData>
                &nbsp;&nbsp;{props.getValues("nameRecipient")}
              </TextData>
            </GridContainText>
            <GridContainText
              item
              xs={12}
              sm={6}
              lg={6}
              style={{ display: "flex", alignItems: "baseline" }}
            >
              {/* <PersonIcon className={`${classes.IconWeight}`} alt="weightOfProducts"/> */}
              <img
                className={`${classes.IconImage}`}
                src={"/assets/Image/Icon/recipient.png"}
                alt="Logo"
              />
              <TextTopic>เบอร์ผู้รับ</TextTopic>
              <TextData>
                &nbsp;&nbsp;{props.getValues("phoneRecipient")}
              </TextData>
            </GridContainText>
            <GridContainText
              item
              xs={12}
              sm={6}
              lg={6}
              style={{ display: "flex", alignItems: "baseline" }}
            >
              <img
                className={`${classes.IconImage}`}
                src={"/assets/Image/Icon/calendar.png"}
                alt="Logo"
              />
              <TextTopic>วันที่</TextTopic>
              <TextData>
                &nbsp;&nbsp;
                {` ${dayjs(props.getValues("date")).format("DD MMMM YY")}`}
              </TextData>
            </GridContainText>
            <GridContainText
              item
              xs={12}
              sm={6}
              lg={6}
              style={{ display: "flex", alignItems: "baseline" }}
            >
              {/* <QueryBuilderIcon className={`${classes.Icon}`}/> */}
              <img
                className={`${classes.IconImage}`}
                src={"/assets/Image/Icon/clock.png"}
                alt="Logo"
              />
              <TextTopic>เวลารับของ</TextTopic>
              <TextData>
                &nbsp;&nbsp;{` ${props.getValues("startTime")} น.`}
              </TextData>
              {/* <Typography className={`${classes.Text}`}>{`${props.getValues("startTime")} น.- ${props.getValues("endTime")} น.`}</Typography> */}
            </GridContainText>
            <GridContainText
              item
              xs={12}
              style={{ display: "flex", alignItems: "baseline" }}
            >
              {/* <RoomIcon className={`${classes.Icon}`}/> */}
              <img
                className={`${classes.IconImage}`}
                src={"/assets/Image/Icon/orderSender.png"}
                alt="Logo"
              />
              <TextTopic>จุดรับของ</TextTopic>
              <TextData>
                &nbsp;&nbsp;{props.getValues("fromPlaceName")}
              </TextData>
            </GridContainText>
            <GridContainText
              item
              xs={12}
              style={{ display: "flex", alignItems: "baseline" }}
            >
              {/* <RoomIcon className={`${classes.Icon}`}/> */}
              <img
                className={`${classes.IconImage}`}
                src={"/assets/Image/Icon/orderRe.png"}
                alt="Logo"
              />
              <TextTopic>จุดส่งของ</TextTopic>
              <TextData>&nbsp;&nbsp;{props.getValues("toPlaceName")}</TextData>
            </GridContainText>
            <GridContainText item xs={12} className={classes.GridTextAndIcon}>
              {/* <ArticleIcon className={`${classes.Icon} ${classes.Recipient}`}/> */}
              <img
                className={`${classes.IconImage}`}
                src={"/assets/Image/Icon/detailOther.png"}
                alt="Logo"
              />
              <TextTopic>รายละเอียดเพิ่มเติม</TextTopic>
              <TextData>&nbsp;&nbsp;{props.getValues("detail")}</TextData>
            </GridContainText>

            {props.getValues("status") && (
              <GridContainText
                item
                xs={12}
                sm={6}
                style={{ display: "flex", alignItems: "baseline" }}
              >
                <HourglassTopIcon
                  className={`${classes.IconImage}`}
                  sx={{ color: "#dca700" }}
                />
                <TextTopic>สถานะ</TextTopic>
                <TextData>&nbsp;&nbsp;{props.getValues("status")}</TextData>
              </GridContainText>
            )}

            {props.getValues("idDriver") && (
              <GridContainText
                item
                xs={12}
                sm={6}
                style={{ display: "flex", alignItems: "baseline" }}
              >
                <img
                  className={`${classes.IconImage}`}
                  src={"/assets/Image/Icon/driverTopic.png"}
                  alt="Logo"
                />
                <TextTopic>คนขับรถ</TextTopic>
                <TextData>&nbsp;&nbsp;{props.getValues("nameDriver")}</TextData>
              </GridContainText>
            )}

            {props.getValues("sendDate") && (
              <GridContainText
                item
                xs={12}
                sm={6}
                style={{ display: "flex", alignItems: "baseline" }}
              >
                <CheckCircleIcon
                  className={`${classes.IconImage}`}
                  sx={{ color: "#2196f3" }}
                />
                <TextTopic>ส่งตัวอย่างสำเร็จ</TextTopic>
                <TextData>
                  &nbsp;&nbsp;
                  {new Date(props.getValues("sendDate")).toLocaleString(
                    "th-TH",
                    {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    }
                  )}
                </TextData>
              </GridContainText>
            )}

            {props.getValues("completedDate") && (
              <GridContainText
                item
                xs={12}
                sm={6}
                style={{ display: "flex", alignItems: "baseline" }}
              >
                <CheckCircleIcon
                  className={`${classes.IconImage}`}
                  sx={{ color: "#00bb77" }}
                />
                <TextTopic>ยืนยันการรับตัวอย่าง :</TextTopic>
                <TextData>
                  &nbsp;&nbsp;
                  {new Date(props.getValues("completedDate")).toLocaleString(
                    "th-TH",
                    {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    }
                  )}
                </TextData>
              </GridContainText>
            )}
          </Grid>
        </div>
      </DialogContent>
      <DialogActions className={classes.DialogActions}>
        <Button
          className={`${classes.Fixed} ${classes.Button}`}
          onClick={props.handleClose}
        >
          <Typography className={`${classes.Text} ${classes.TextButton}`}>
            แก้ไข
          </Typography>
        </Button>
        <Button
          className={`${classes.Confirm} ${classes.Button}`}
          onClick={props.onClickSubmit}
        >
          <Typography className={`${classes.Text} ${classes.TextButton}`}>
            ยืนยัน
          </Typography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogShowDetailBooking;
